var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('step-component',[_c('shipment-select',{attrs:{"lab_id":"activeSampleLabId","initial-info":"Most recent open shipment is selected, to choose a different open select the down arrow.","show-create-new":true},model:{value:(_vm.shipmentId),callback:function ($$v) {_vm.shipmentId=$$v},expression:"shipmentId"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }